import React from 'react'
import qs from 'qs'
import { createBrowserHistory } from 'history';

//utils
import callApi from '../../utils/callApi';

//constants
import {
    ANCHOR_FEATURED_LIST_SEGMENTS,
    ANCHOR_FEATURED_LIST_AUDITIONS,
    ANCHOR_FEATURED_LIST_GALLERIES,
    ANCHOR_VIDEOS_AND_GALLERIES,
    ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_FOR_SALE,
    ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_PURCHASED,
    ANCHOR_FEATURED_ALL_CLIPSTORE_ITEMS_FOR_SALE,
    ANCHOR_FEATURED_ALL_CLIPSTORE_ITEMS_PURCHASED,
    LIST_EPAY_PACKAGES_ITEM,
    ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_EWALLET
} from '../../constants/apiUrls/apiUrls'

//components
import PageSubnav from '../featuredComponents/PageSubnav';
import FeaturedItems from '../anchorComponents/FeaturedItems';
import SimpleVideoPlayer from './SimpleVideoPlayer';
import PrivateGalleriesAndVideos from './PrivateGalleriesAndVideos/PrivateGalleriesAndVideos';
import { checkStatus } from '../App/services';
import { overrideStatusResponse } from '../../utils/overrideStatusResponse';
import LockIcon from '@material-ui/icons/Lock';
import { RootStoreContext } from '../../context';
import PayPerViewPurchaseModal from "../PayPerViewPurchaseModal/PayPerViewPurchaseModal";
import Loader from 'react-simple-loading';
import PayPerViewStore from '../../store/PayPerViewStore';
import { observer } from 'mobx-react';
import TippingStore from '../../store/TippingStore';

// const PageSubnavLinks = ['Segments', 'Galleries', 'Audition'];
const history = createBrowserHistory();
const nnLiveId = '241';

const CLIPSTORE_URLS = {
  ALL_NEW: ANCHOR_FEATURED_ALL_CLIPSTORE_ITEMS_FOR_SALE,
  ALL_PURCHASED: ANCHOR_FEATURED_ALL_CLIPSTORE_ITEMS_PURCHASED,
  ANCHOR_NEW: ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_FOR_SALE,
  ANCHOR_PURCHASED: ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_PURCHASED,
};

@observer
class FeaturedSection extends React.Component {
  static contextType = RootStoreContext;
    constructor(props) {
        super(props);
        window.FeaturedSection = this;
        this.queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        this.state = {
          typeOfListing: 'segments',
          featuredItems: [],
          size: 15,
          isLoading: false,
          itemCount: 0,
          clipStoreNewItemCount: 0,
          clipStorePurchasedItemCount: 0,
          featuredDataReady: false,
          featureExists: {
            segments: false,
            galleries: false,
            audition: false,
            fanzone: false,
            clipstore: false
          },
          subscribedToAnchor: false,
          privateGalleries: [],
          privateVideos: [],
          galleriesAndVideos: [],
          clipStoreItemsForSale: [],
          clipStoreItemsPurchased: [],
          user: {},
          pagination: {
            total: 0,
            page: 0,
            pageSize: 30,
            totalPages: 0
          },
          payPerViewNewItemPage: 0,
          payPerViewNewItemTotalPages: 0,
          payPerViewPurchasedItemPage: 0,
          payPerViewPurchasedItemTotalPages: 0,
          loadingFanZoneContent: false,
          currentFeaturedItemsCount: 0,
          allDataLoaded: false,
          hiddenLibrariesCount: 0,
          clipStoreNewHiddenLibrariesCount: 0,
          clipStorePurchasedHiddenLibrariesCount: 0,
          isBanned: false,
          clipStoreLoading: false,
          totalNewPayPerViewItems: 0,
          totalPurchasedPayPerViewItems: 0,
          selectedClipPrice: {price: 0, title: "", id: 0, type: ""},
          packages: [],
        }
    }

    getPageSubnavLinks = () => {
      const { featureExists, subscribedToAnchor, itemCount } = this.state;
      const { id, showClipStore, showFanZone } = this.props;

      let isNNLive = (id === nnLiveId);
      let features = ['segments', 'audition'];

      if(itemCount > 0) {
        if(!subscribedToAnchor && parseInt(id,10) === 120){
          features = ['segments', 'audition'];
        } else {
          if ((showFanZone) || isNNLive) {
          features.push('fan zone')
          }
          if (showClipStore || isNNLive) {
            features.push('clipstore');
          }
        }
      }

      const pageSubnavLinks = [];
      features.forEach(feature => {
        if (feature === 'clipstore' && featureExists[feature.replace(/\s/g,"")] && showClipStore){
          pageSubnavLinks.push('Clip Store');
        }
        else if (feature === 'fan zone' && featureExists[feature.replace(/\s/g,"")] && showFanZone) {
          pageSubnavLinks.push("fan zone")
        }
        else if (feature === 'fan zone' && featureExists[feature.replace(/\s/g,"")] && isNNLive) {
          pageSubnavLinks.push("galleries & videos")
        }
        else if (featureExists[feature.replace(/\s/g,'')] && feature !== 'clipstore') pageSubnavLinks.push(feature.toUpperCase()) ;
});
      return pageSubnavLinks;
    }

    getUrlByTypeOfListing = (type) => {
      const typeOfListing = type || this.state.typeOfListing;

      switch (typeOfListing) {
        case "segments":
          return ANCHOR_FEATURED_LIST_SEGMENTS;
        case "audition":
          return ANCHOR_FEATURED_LIST_AUDITIONS;
        case "galleries":
          return ANCHOR_FEATURED_LIST_GALLERIES;
        case "clipstore":
          return ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_FOR_SALE;
        default:
            return ANCHOR_FEATURED_LIST_SEGMENTS;
      }
    }

    loadMore = () => {
      const { size } = this.state;
      this.setState({isLoading: true, size: size + 15, featuredItems: []}, () => this.setFeaturedItemsList());
    }

    decideURL = (payPerViewNav, dropDownOption) => {
      if (payPerViewNav === 'New' && dropDownOption !== 'All') {

        return CLIPSTORE_URLS.ANCHOR_NEW;
      } else if (payPerViewNav === 'Purchased' && dropDownOption !== 'All') {

        return CLIPSTORE_URLS.ANCHOR_PURCHASED;
      } else if (payPerViewNav === 'New' && dropDownOption === 'All') {

        return CLIPSTORE_URLS.ALL_NEW;
      } else {

        return CLIPSTORE_URLS.ALL_PURCHASED;
      }
    }

    fetchListingType = (type, payPerViewNav) => {
      const { size } = this.state;
      const { id, dropdownOption } = this.props;

      const urlByTypeOfListing = this.getUrlByTypeOfListing(type);
      let url
      if(type !== 'clipstore'){
      url = urlByTypeOfListing.replace('{page}', 0)
                                  .replace('{size}', size)
                                  .replace('{id}', id);

      return callApi(url, 'get', {}, true, true, true);
      }
      else {

        url = this.decideURL(payPerViewNav, dropdownOption);
        url = url.replace('{page}', 0)
                  .replace('{size}', 9)
                  .replace('{id}', id);

          return callApi(url, 'get', {}, {}, {}, true, true, true)
        }
    }

    setFeaturedItemsList = (type) => {
      const { currentFeaturedItemsCount } = this.state;

      this.fetchListingType(type)
      .then(res => {
        // Logic for removing the 'Load More' button on Segments and Galleries sections
        let allDataLoaded = (res.data.length - currentFeaturedItemsCount < 15);

        this.setState({
          featuredItems: res.data,
          isLoading: false,
          currentFeaturedItemsCount: res.data.length,
          allDataLoaded
        })
      });
    }

    setFeaturedItemExistence = (data, featuredItem) => {

      if (data.length > 0 || (Object.keys(data).length > 0)) {
        this.setState(state => {
          return {
            featureExists: {
              ...state.featureExists,
              [featuredItem]: true
            }
          }
        })
      }
    }

    componentDidMount = () => {
      const { location, user, showFanZone, id, isClipStorePage } = this.props;
      const isNNLive = (id === nnLiveId);
      const username = sessionStorage.getItem('username') || (user.user && user.user.username);
      const token = sessionStorage.getItem('token') || (user.user && user.user.token);

      PayPerViewStore.setShowPayPerViewModal(false);
      PayPerViewStore.setPayPerViewNav('New');

      callApi(LIST_EPAY_PACKAGES_ITEM, 'get', {token: token, userName: username}, {}, {}, false, false, false)
      .then(res => {
        this.setState({packages: res.data.products})
      });

      if (isClipStorePage) {
          this.fetchListingType('clipstore', 'New')
          .then(payPerViewRes => {
            this.setFeaturedItemExistence(payPerViewRes.data, 'clipstore');
            this.setState({totalNewPayPerViewItems: payPerViewRes.data.totalElements, payPerViewNewItemTotalPages: payPerViewRes.data.totalPages, clipStoreItemsForSale: payPerViewRes.data.content});
            if (user.authenticated) {
              this.fetchListingType('clipstore', 'Purchased')
              .then(res => {
                this.setFeaturedItemExistence(res.data, 'clipstore')
                this.setState({payPerViewPurchasedItemTotalPages: res.data.totalPages, totalPurchasedPayPerViewItems: res.data.totalElements});
              })
            }
          });
      }

        if (location.search) {
            const parsedSearch = qs.parse(location.search, {
                ignoreQueryPrefix: true
            });

            switch (parsedSearch.filter) {
                case 'segments':
                    this.setState({ typeOfListing: parsedSearch.filter });
                    break;

                case 'galleries':
                    this.setState({ typeOfListing: parsedSearch.filter });
                    break;

                case 'audition':
                    this.setState({ typeOfListing: parsedSearch.filter });
                    break;

                case 'fanzone':
                    this.setState({ typeOfListing: parsedSearch.filter });
                    break;

                case 'clipstore':
                    this.setState({ typeOfListing: parsedSearch.filter });
                    break;

                default:
                    break;
            }
        }

      let auditionContent = null;
      this.fetchListingType('segments')
      .then(segmentsRes => {
        this.setFeaturedItemExistence(segmentsRes.data, 'segments');
        this.fetchListingType('galleries')
        .then(galleriesRes => {
          this.setFeaturedItemExistence(galleriesRes.data, 'galleries');
          if (this.props.showClipStore) {
            this.fetchListingType('clipstore', 'New')
            .then(payPerViewRes => {
              this.setFeaturedItemExistence(payPerViewRes.data, 'clipstore');
              this.setState({totalNewPayPerViewItems: payPerViewRes.data.totalElements, payPerViewNewItemTotalPages: payPerViewRes.data.totalPages, clipStoreItemsForSale: payPerViewRes.data.content});
              if (user.authenticated) {
                this.fetchListingType('clipstore', 'Purchased')
                .then(res => {
                  this.setFeaturedItemExistence(res.data, 'clipstore')
                  this.setState({payPerViewPurchasedItemTotalPages: res.data.totalPages, totalPurchasedPayPerViewItems: res.data.totalElements});
                })
              }
            });}
          this.fetchListingType('audition')
          .then(auditionRes => {
            this.setFeaturedItemExistence(auditionRes.data, 'audition');
              auditionContent = auditionRes;

          }).catch(() => {
              // shitty workaround because BE returns 404 instead of empty response if content is empty
              this.setFeaturedItemExistence([], 'audition');
          }).finally(() => {
            const {
              opStatus,
              productType1,
            } = this.queryParams;
            if (opStatus === 'FAILED' && productType1 === 'GIFT') {
              this.setState({ featuredDataReady: true });
              this.setState({ typeOfListing: 'fanzone'});
            }
            else {
            if (location.search === "?filter=clipstore" || location.pathname === "/clip-store") {
              PayPerViewStore.setPayPerViewNav('New');
              this.setState({typeOfListing: "clipstore", featuredDataReady: true});
            }
            else if ((location.search === "?filter=fanzone" && showFanZone) || isNNLive) {
              this.setDefaultFeature("fanzone");
              this.setState({featuredDataReady:true});
            }
            else {
              if(segmentsRes.data.length === 0) {
                  if (galleriesRes.data.length) {
                      this.setDefaultFeature('galleries');
                  } else {
                      if(auditionContent && auditionContent.data.length) {
                          this.historyPush('audition');
                      } else if (this.state.itemCount > 0 && showFanZone) {
                          this.setDefaultFeature('fanzone');
                      }
                  }
              } else {
                  this.setDefaultFeature('segments');
              }
              this.setState({ featuredDataReady: true });}
          }})
        })
      });
      this.checkSubscriptionStatus();
    };

    // used only when there are no segments.
    // feature can be of type segments, fanzone, audition, galleries
    setDefaultFeature = (feature) => {
        this.historyPush(feature);
        this.setFeaturedItemsList(feature);
        this.setState({ typeOfListing: feature });
    };

    checkSubscriptionStatus = async () => {
      const { id } = this.props;

      const { error, data } = await checkStatus();

      if (!error) {
        await overrideStatusResponse(data);

        const anchorSubscriptions = data?.data?.user?.account.anchorSubscriptions;
        const isAnchor = data?.data?.user?.account?.anchor;
        this.checkIfUserIsWhitelisted(data);

        if(anchorSubscriptions) {
          const subscribed = anchorSubscriptions.filter(anchor => anchor.subCategory === id);
          let isBanned = false;

          if (subscribed.length > 0) {
            isBanned = subscribed[0].isBanned;
            this.props.setBanStatus(isBanned)
          };

          if(subscribed.length > 0 || isAnchor) {
            this.setState({ subscribedToAnchor: true, user: data.data.user, isBanned });
          } else {
            this.setState({ subscribedToAnchor: false, isBanned});
          }

        };
      } else {
        console.error(error)
      };
    };

    checkIfUserIsWhitelisted = res => {
      const { featureExists } = this.state;

      const whitelisted = res.data.features.includes("ANCHOR_PORTAL");

      if(whitelisted) {
        const features = {
          ...featureExists,
          fanzone: whitelisted,
          clipstore: (this.props.id === nnLiveId && whitelisted)
        };

        this.setState({ featureExists: features}, this.fetchPrivateVideosAndGalleries, (this.props.id === nnLiveId && this.fetchPayPerViewVideosAndGalleries));

      };
    };

    fetchPayPerViewVideosAndGalleries = (selectedLink) => {
      const { clipStoreItemsForSale,
              clipStoreItemsPurchased,
              payPerViewNewItemPage,
              payPerViewPurchasedItemPage,
            } = this.state;

      const { id, dropdownOption } = this.props;
      const anchorID = id || PayPerViewStore.currentlySelectedAnchorID;
      let url = this.decideURL(selectedLink, dropdownOption)

      url = url.replace('{page}', (selectedLink === 'New' ? payPerViewNewItemPage : payPerViewPurchasedItemPage))
              .replace('{size}', 9)
              .replace('{id}', anchorID);

        callApi(url, 'get', {}, {}, {}, true, true, true)
        .then(res => {
          const { totalElements } = res.data;

          selectedLink === "New" ? this.setState({clipStoreNewItemCount: totalElements, totalNewPayPerViewItems: totalElements}) : this.setState({clipStorePurchasedItemCount: totalElements})

          if (res.status === 200 && res.data){
          (selectedLink === "New") ? this.setState({clipStoreItemsForSale: res.data.content, payPerViewNewItemPage: res.data.pageNumber}) :
          this.setState({clipStoreItemsPurchased: res.data.content, payPerViewPurchasedItemPage: res.data.pageNumber})

          // Display only videos and galleries that are not empty
          const galleriesAndVideosNew = res.data.content.filter(item => item.type === 'VIDEO' || item.imageCount >= 0);

          // Keep track of the number of hidden Galleries (needed for hiding the Load More button logic)
          const clipStoreHiddenLibrariesCount = res.data.content.length - galleriesAndVideosNew.length;

          // Load more - add new data to the ones already displayed

          const moreGalleriesAndVideos = (selectedLink === "New") ? [...clipStoreItemsForSale, ...galleriesAndVideosNew] : [...clipStoreItemsPurchased, ...galleriesAndVideosNew];

          selectedLink === "New" ? this.setState({clipStoreItemsForSale: moreGalleriesAndVideos}) : this.setState({clipStoreItemsPurchased: moreGalleriesAndVideos})

          if(clipStoreHiddenLibrariesCount > 0) {
            selectedLink === 'New' ? this.setState({clipStoreNewHiddenLibrariesCount: clipStoreHiddenLibrariesCount}) : this.setState({clipStorePurchasedHiddenLibrariesCount: clipStoreHiddenLibrariesCount})
            this.setState({ loadingFanZoneContent: false});
          } else {
            this.setState({ loadingFanZoneContent: false});
          };
        }

        else {return}
        })
        .catch(error => {
          console.error(error);
        });
    }

    fetchPrivateVideosAndGalleries = () => {
      const { galleriesAndVideos } = this.state;
      const { id, pageItemsShown } = this.props;
      const { page, pageSize } = this.state.pagination;

      const params = {
        page,
        size: pageItemsShown || pageSize
      };

      const url = ANCHOR_VIDEOS_AND_GALLERIES.replace('{anchorId}', encodeURIComponent(id));
      callApi(url, 'get', params, {}, {}, true, true, true)
        .then(res => {
          if (res.status === 200 && res.data) {
            const { totalElements } = res.data;
            this.setState({ itemCount: totalElements });
            this.props.setItemsCount && this.props.setItemsCount(totalElements);
            const pagination = {
              ...this.state.pagination,
              total: res.data.totalElements,
              pageSize: this.state.size + 15,
              page: res.data.pageNumber,
              totalPage: res.data.totalPages
            };
            // Display only videos and galleries that are not empty
            const galleriesAndVideosNew = res.data.content.filter(item => item.type === 'VIDEO' || item.imageCount > 0);

            // Keep track of the number of hidden Galleries (needed for hiding the Load More button logic)
            const hiddenLibrariesCount = res.data.content.length - galleriesAndVideosNew.length;

            // Load more - add new data to the ones already displayed
            const moreGalleriesAndVideos = [...galleriesAndVideos, ...galleriesAndVideosNew];

            if(hiddenLibrariesCount > 0) {
              this.setState({ loadingFanZoneContent: false, galleriesAndVideos: moreGalleriesAndVideos, pagination, hiddenLibrariesCount });
            } else {
              this.setState({ loadingFanZoneContent: false, galleriesAndVideos: moreGalleriesAndVideos, pagination });
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    };

    handlePageChanged = (pageNum) => {
      let { page } = this.state.pagination;
      let next = ++page;

      this.setState(state => {
        return {
          loadingFanZoneContent: true,
          pagination: { ...state.pagination, page: next  }
        };
      }, () => {
        this.fetchPrivateVideosAndGalleries();
      });
    };

    handleFreeContentForFanPlus = (id, price, type) => {
      const url = ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_EWALLET.replace('{anchorId}', encodeURIComponent(this.props.id));
      const body = JSON.stringify({
        itemId: id,
        price: price,
        itemType: type
      });
      this.setState({ clipStoreLoading: true });
      callApi(url, 'post', {}, body, {}, true, true, true).then(res => {
        if(res.status === 200) {
          this.setState({ clipStoreLoading: false });
          this.openPurchased();
        }
      }).catch(e => {
        this.setState({ clipStoreLoading: false });
      });
    }

    handlePayPerViewPageChanged = (pageNum) => {
      const payPerViewNav = PayPerViewStore.payPerViewNav;
      const { payPerViewNewItemPage, payPerViewPurchasedItemPage } = this.state;
      let currentPage = (payPerViewNav === 'New' ? payPerViewNewItemPage : payPerViewPurchasedItemPage)
      const next = ++currentPage;

      payPerViewNav === 'New' ?
        this.setState({ loadingFanZoneContent: true, payPerViewNewItemPage: next }, () => {
        this.fetchPayPerViewVideosAndGalleries(payPerViewNav);
    }) :
        this.setState({ loadingFanZoneContent: true, payPerViewPurchasedItemPage: next}, () => {
        this.fetchPayPerViewVideosAndGalleries(payPerViewNav);
      });
    };

    historyPush = filter => {
      const { location, anchorShortUrl } = this.props;
      history.push({
          pathname: location.pathname ,
          search: (anchorShortUrl !== "live") ?`filter=${filter}` : ""
      })
    };

    setPayPerViewNav = (e) => {
      const payPerViewNav = PayPerViewStore.payPerViewNav;
      const clickedLink = e.target.classList[0];

      if (payPerViewNav !== clickedLink) {
        PayPerViewStore.setPayPerViewNav(clickedLink);
        this.clearClipStoreItems();
        this.fetchPayPerViewVideosAndGalleries(clickedLink);
      };
    };

    setPayPerViewClipData = (price, title, id, type) => {
      this.setState({selectedClipPrice: {price: price, title: title, id: id, type: type}});
    }

    openPayPerViewModal = (price, title, id, type, customPriceForFanPlus) => {
      const { user } = this.props;
      const isAnchor = user && user.user ? user.user.account.anchor : false;
      this.setPayPerViewClipData(price, title, id, type);

      if (!isAnchor && customPriceForFanPlus === 0 && price === 0) {
        this.handleFreeContentForFanPlus(id, price, type);
      }

      if (!isAnchor && (price !== 0 && title !== "")) {
        PayPerViewStore.setShowPayPerViewModal(true);
      }

      PayPerViewStore.setPurchasedClip({id: id, type: type.toString()});
    };

    closePayPerViewModal = () => {
      PayPerViewStore.setShowPayPerViewModal(false);
      PayPerViewStore.setStatusMessage("");
    };

    openPurchased = () => {
      this.clearClipStoreItems();
      this.fetchPayPerViewVideosAndGalleries("Purchased");
    }

    startPurchaseEventTimerCountDown = () => {
      PayPerViewStore.setTimerStarted(true);
      const timer = setTimeout(() => {

        if (PayPerViewStore.timerStarted && PayPerViewStore.intervalID) {
        PayPerViewStore.setStatusMessage("There was an error. Please try again later.");
        PayPerViewStore.setShowPayPerViewModal(true);
        PayPerViewStore.setPaymentLoading(false);
        }
        else {
          PayPerViewStore.setTimerStarted(false);
        }
      }, 30000);
      PayPerViewStore.setIntervalID(timer);
    }

    componentWillUnmount() {
      if (PayPerViewStore.intervalID !== null) {
          clearTimeout(PayPerViewStore.intervalID);
          PayPerViewStore.setIntervalID(null);
      }
      PayPerViewStore.setPayPerViewNav('New');
    }

    handleClick = (e) => {
      const { typeOfListing } = this.state;
      const preparedTargetValue = e.currentTarget.text.toLowerCase().replace(/\s/g, '');

      e.preventDefault();

      switch (preparedTargetValue) {
        case 'segments':
            this.historyPush(preparedTargetValue);
            break;

        case 'galleries':
            this.historyPush(preparedTargetValue);
            break;

        case 'audition':
            this.historyPush(preparedTargetValue);
            break;

        case 'fanzone':
          this.historyPush(preparedTargetValue);
          break;

        case 'clipstore':
          this.historyPush(preparedTargetValue);
          break;

        default:
            break;
    }
      if ((preparedTargetValue !== typeOfListing) && preparedTargetValue === 'clipstore'){
        PayPerViewStore.setPayPerViewNav("New")
        this.setState({ typeOfListing: preparedTargetValue, featuredItems: [], currentFeaturedItemsCount: 0, size: 6, clipStoreItemsForSale: [], clipStoreItemsPurchased: [], payPerViewNewItemPage: 0, payPerViewPurchasedItemPage: 0}, () => this.fetchPayPerViewVideosAndGalleries('New'));
      }
      else if (preparedTargetValue !== typeOfListing) {
        this.setState({typeOfListing: preparedTargetValue === "galleries&videos" ? "fanzone" : preparedTargetValue, featuredItems: [], currentFeaturedItemsCount: 0, size: 15, clipStoreItemsForSale: [], clipStoreItemsPurchased: []}, () => this.setFeaturedItemsList());
      };
    };

    clearClipStoreItems = () => {
      this.setState({
          payPerViewNewItemPage: 0,
          payPerViewPurchasedItemPage: 0,
          clipStoreItemsPurchased: [],
          clipStoreItemsForSale: [],
          clipStoreNewHiddenLibrariesCount: 0,
          clipStorePurchasedHiddenLibrariesCount: 0,
          totalNewPayPerViewItems: 0,
          totalPurchasedPayPerViewItems: 0,
      });
    }

    componentDidUpdate(prevProps) {
      const { dropdownOption } = this.props || {};
      if ((prevProps.dropdownOption && prevProps.dropdownOption !== dropdownOption) || PayPerViewStore.shouldRefreshItemsList) {
        this.setState({ dropDownOption: dropdownOption }, () => { this.fetchPayPerViewVideosAndGalleries('New')});
        this.clearClipStoreItems();
        PayPerViewStore.setPayPerViewNav('New');
        PayPerViewStore.setShouldRefreshItemsList(false);
      }
    }

    renderLockerContentInfo = () => {
      const { anchorName } = this.props;
      return (
        <div className='container'>
          <div className="locked-content-note fan-zone-locked-content">
            <div className="lock-icon">
              <LockIcon style={{ fontSize: "20px" }} />
            </div>
            <div className="locked-content-info">
              {`The content in this section is only available to ${anchorName}'s Fans`}
            </div>
          </div>
        </div>
      )
    }

    renderNoContentDisclaimer = () => {
      const { anchorName } = this.props;
      return (
        <div className='purchased-tab flex'>
          <div>
            <h3>There's nothing else available around here at the moment!</h3>
            <h4>{`Let ${anchorName} know that you're looking forward to purchasing 
                  more exclusive content or come back later to see what's new in store!`}
            </h4>
          </div>
      </div>
      )
    }

    render() {
      const {
        typeOfListing,
        featuredItems,
        isLoading,
        featuredDataReady,
        subscribedToAnchor,
        user,
        galleriesAndVideos,
        loadingFanZoneContent,
        allDataLoaded,
        hiddenLibrariesCount,
        itemCount,
        totalNewPayPerViewItems,
        clipStorePurchasedItemCount,
        clipStoreNewHiddenLibrariesCount,
        clipStorePurchasedHiddenLibrariesCount,
        clipStoreItemsForSale,
        clipStoreItemsPurchased,
        clipStoreLoading,
        selectedClipPrice,
        modalMessage,
        shouldShowDiscountModal,
      } = this.state;
      const {
        anchorName,
        id,
        anchorShortUrl,
        extractIdFromSlug,
        isClipStorePage,
      } = this.props;
      const anchors = this.props.anchors || [];
      const isAnchor = this.props.user?.user?.account?.anchor;
      const { anchorSubscriptions } = this.props.user.authenticated && this.props.user.user.account;
      const selectedAnchorId = id ? id : extractIdFromSlug();
      const isSubscribed = this.props.user.authenticated && anchorSubscriptions && anchorSubscriptions.find(sub => sub.subCategory === selectedAnchorId);
      const isNNLivePage = id === nnLiveId;
      const showPageSubNav = featuredDataReady && !isClipStorePage && (typeOfListing === "segments" || "galleries" || "audition" || "fanzone" || "clipstore");
      const shouldShowLockedContentInfo = (!isSubscribed && !isAnchor) && !isNNLivePage && typeOfListing === 'fanzone';
      const shouldShowFeaturedItems = typeOfListing !== "audition" && typeOfListing !== "fanzone" && typeOfListing !== 'clipstore';
      const showAuditionClip = typeOfListing === "audition" && featuredItems.position;
      const isFanzone = typeOfListing === 'fanzone';
      const paymentIsLoading = PayPerViewStore.paymentLoading || clipStoreLoading;
      return (
        <React.Fragment>
          {
            showPageSubNav &&
              <PageSubnav
                isNNLivePage={isNNLivePage}
                handleClick={this.handleClick}
                typeOfListing={typeOfListing}
                links={this.getPageSubnavLinks()}
              />}
          {shouldShowLockedContentInfo && this.renderLockerContentInfo()}
          {shouldShowFeaturedItems &&
            <div className='fan-zone-anchor-page'>
              <FeaturedItems
                typeOfListing={typeOfListing}
                featuredItems={featuredItems}
                loadMore={this.loadMore}
                isLoading={isLoading}
                allDataLoaded={allDataLoaded}
              />
            </div>}
          {showAuditionClip &&
            <div className="content audition-page-player fan-zone-anchor-page">
              <SimpleVideoPlayer audition={featuredItems} />
            </div>}
          {isFanzone &&
            <div className={`content ${anchorShortUrl === "live" ? "live-page-content" : "fan-zone-anchor-page"}`}>
              <PrivateGalleriesAndVideos
                anchors={anchors}
                subscribed={subscribedToAnchor}
                galleriesAndVideos={galleriesAndVideos}
                galleriesAndVideosCount={itemCount}
                hiddenLibrariesCount={hiddenLibrariesCount}
                anchorId={id}
                user={this.props.user}
                handlePageChanged={this.handlePageChanged}
                isLoading={loadingFanZoneContent}
                anchorShortUrl={anchorShortUrl}
                typeOfListing={typeOfListing}
                setPayPerViewClipData={this.setPayPerViewClipData}
              />
            </div>}
          {paymentIsLoading &&
            <div className="payment-loading-overlay">
              <Loader />
            </div>}
          {(typeOfListing === "clipstore") && featuredDataReady &&
            <>
              <div className='pay-per-view-nav container'>
                <div
                  className={`New ${PayPerViewStore.payPerViewNav === "New" ? "active" : ""}`}
                  onClick={this.setPayPerViewNav}
                >
                    New
                </div>
                {!isAnchor &&
                  <div
                    className={`Purchased ${!this.props.user.authenticated && "disable-click"} ${PayPerViewStore.payPerViewNav === "Purchased" ? "active" : ""}`}
                    onClick={this.setPayPerViewNav} >
                      Purchased
                  </div>}
              </div>
              <div className={`content ${isNNLivePage ? "live-page-content" : "fan-zone-anchor-page pay-per-view"}`}>
                {PayPerViewStore.payPerViewNav === "New" ?
          <>
            {totalNewPayPerViewItems > 0 ?
            <>
            {PayPerViewStore.showPayPerViewModal &&
            <PayPerViewPurchaseModal
                anchors={anchors}
                anchorName={anchorName}
                anchorShortUrl={anchorShortUrl}
                closeModal={this.closePayPerViewModal}
                buyClip={this.buyPayPerViewClip}
                price={selectedClipPrice.price}
                title={selectedClipPrice.title}
                message={modalMessage}
                user={this.props.user}
                anchorId={PayPerViewStore.currentlySelectedAnchorId || this.props.id}
                programs={this.state.packages}
                type={selectedClipPrice.type}
                clipId={selectedClipPrice.id}
                startPurchaseTimer={this.startPurchaseEventTimerCountDown}
                fetchPayPerViewVideosAndGalleries={this.fetchPayPerViewVideosAndGalleries}
                />}
            <div className='container total-posts'>{totalNewPayPerViewItems} new posts for sale</div>
            <PrivateGalleriesAndVideos
                anchors={anchors}
                isPurchasedTab={false}
                subscribed={subscribedToAnchor}
                galleriesAndVideos={clipStoreItemsForSale}
                galleriesAndVideosCount={totalNewPayPerViewItems}
                hiddenLibrariesCount={clipStoreNewHiddenLibrariesCount}
                anchorId={id}
                user={this.props.user}
                handlePageChanged={this.handlePayPerViewPageChanged}
                isLoading={loadingFanZoneContent}
                typeOfListing={typeOfListing}
                payPerViewNav={PayPerViewStore.payPerViewNav}
                openPayPerViewModal={this.openPayPerViewModal}
                isClipStorePage={isClipStorePage}
                setPayPerViewClipData={this.setPayPerViewClipData}
            />
           </>
           :
              this.renderNoContentDisclaimer()
          }
           </>
           :
          <>
            {clipStoreItemsPurchased.length > 0 ?
              <PrivateGalleriesAndVideos
                anchors={anchors}
                isPurchasedTab={true}
                subscribed={subscribedToAnchor}
                galleriesAndVideos={clipStoreItemsPurchased}
                galleriesAndVideosCount={clipStorePurchasedItemCount}
                hiddenLibrariesCount={clipStorePurchasedHiddenLibrariesCount}
                anchorId={id}
                user={this.props.user}
                handlePageChanged={this.handlePayPerViewPageChanged}
                isLoading={loadingFanZoneContent}
                typeOfListing={typeOfListing}
                payPerViewNav={PayPerViewStore.payPerViewNav}
                selectedClipPrice={selectedClipPrice}
                isClipStorePage={isClipStorePage}
                setPayPerViewClipData={this.setPayPerViewClipData}
              /> :
              <div className='purchased-tab'>You have not purchased any exclusive content yet.</div>}
         </>
          }
        </div>
        </>}
  </React.Fragment>
  )};
};
export default FeaturedSection;

FeaturedSection.defaultProps = {
  dropdownOption: 'Anchors',
}
